import { render, staticRenderFns } from "./explanation-request-add-modal.vue?vue&type=template&id=c4178580&"
import script from "./explanation-request-add-modal.vue?vue&type=script&lang=js&"
export * from "./explanation-request-add-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4178580')) {
      api.createRecord('c4178580', component.options)
    } else {
      api.reload('c4178580', component.options)
    }
    module.hot.accept("./explanation-request-add-modal.vue?vue&type=template&id=c4178580&", function () {
      api.rerender('c4178580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/ExplanationRequests/explanation-request-add-modal.vue"
export default component.exports